import type { BrandConfig } from "./types.js";
import chuhaijiangData from "./chuhaijiang.json" with { type: "json" };
import trenzData from "./trenz.json" with { type: "json" };

export type { BrandConfig } from "./types.js";

// Vite 通过 vite.config.ts 的 `define` 把 __BRAND__ 替换成字面量字符串
// （例如 "trenz"），确保 client bundle + SSR 两侧 brand 选择一致。
// zudoku 加载 config.tsx 等 Node-only 场景，__BRAND__ 未定义时回退到
// process.env.BRAND，两者都缺则默认 chuhaijiang。
declare const __BRAND__: string | undefined;

const registry: Record<string, BrandConfig> = {
  chuhaijiang: chuhaijiangData as BrandConfig,
  trenz: trenzData as BrandConfig,
};

function pickBrandName(): string {
  if (typeof __BRAND__ !== "undefined" && __BRAND__) return __BRAND__;
  if (typeof process !== "undefined" && process.env?.BRAND) return process.env.BRAND;
  return "chuhaijiang";
}

const raw = pickBrandName().trim().toLowerCase();
const resolved = registry[raw];

if (!resolved) {
  const known = Object.keys(registry).join(", ");
  throw new Error(
    `[brands] unknown BRAND="${raw}", expected one of: ${known}`,
  );
}

export const brand: BrandConfig = resolved;

// 暴露 brand.lang 给 zudoku 的 patch —— OperationListItem.tsx 里的 pricing badge
// 文案要跟随 brand 做 i18n，但 zudoku 内部模块无法直接 import 我们的 brand 配置，
// 只能通过 globalThis 桥接。这里在模块顶层同步写入，SSR（node globalThis）和
// client bundle（window）都会执行；brand 模块被 zudoku.config.tsx（SSR）以及
// Hero/FeatureGrid/EndpointShowcase 等 client 组件 import，保证两侧都覆盖。
if (typeof globalThis !== "undefined") {
  (globalThis as Record<string, unknown>).__DOC_LANG__ = brand.lang;
}
